module.exports = __webpack_public_path__ + "img/cartoon-header.40a0ed04.jpg";